import useOrganizationContext from "hooks/useOrganizationContext";
import { useQuery } from "react-query";
import { getAllPopulations } from "api/api-hooks/event-config/event-config-populations/api";
import Population from "models/population";

export const useGetAllPopulations = ({
	eventId,
	queryParams = {},
	options = {}
}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	const defaultParams = {
		...queryParams
	};

	return useQuery(
		["populations-list", organizationId, eventId, defaultParams],
		() =>
			getAllPopulations({
				organizationId,
				eventId,
				params: defaultParams
			}).then(({ response }) => response.map(Population.buildFromJSON)),
		{
			...options,
			enabled:
				(options?.enabled ?? true) &&
				Boolean(organizationId) &&
				Boolean(eventId)
		}
	);
};
